import { FormattedMessage, useIntl } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import MicroFileItemForm from "./MicroFileItemForm";
import MicrofilmSelectField from "./MicrofilmSelectField";

function MicrofilmForm({
  dir,
  currentLocale,
  userInfo,
  register,
  handleSubmit,
  errors,
  onSubmit,
  services,
  agencies,
  films,
}) {
  const intl = useIntl();

  return (
    <div className="col-lg-8">
      <div className="m__title">
        <h3>
          <FormattedMessage id="microfilm" />
        </h3>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <MicrofilmSelectField
          label={
            <>
              <FormattedMessage id="service-type" />:
            </>
          }
          dir={dir}
          currentLocale={currentLocale}
          registerProps={register("serviceTypeId")}
          options={services}
          translationKey="serviceTypeTranslations"
        />

        <MicroFileItemForm
          label={intl.formatMessage({ id: "clientFirstName" })}
          isOptional={true}
        >
          <input
            type="text"
            disabled
            value={userInfo.firstName}
            className="form-control"
          />
        </MicroFileItemForm>

        <MicroFileItemForm
          label={intl.formatMessage({ id: "clientLastName" })}
          isOptional={true}
        >
          <input
            type="text"
            disabled
            value={userInfo.lastName}
            className="form-control"
          />
        </MicroFileItemForm>

        <div className="form-label row">
          <div className="col-lg-4">
            <label>
              <FormattedMessage id="entity-name" />:
            </label>
          </div>
          <div className="col-lg-8">
            <div className="form-label-container">
              <input
                type="text"
                {...register("agencyName")}
                className={`form-control ${
                  errors.agencyName ? "is-invalid" : ""
                }`}
              />
              <span>*</span>
            </div>
          </div>
        </div>

        <MicroFileItemForm
          label={intl.formatMessage({ id: "email" })}
          isOptional={true}
        >
          <input
            type="text"
            disabled
            value={userInfo.email}
            className="form-control"
          />
        </MicroFileItemForm>

        <MicrofilmSelectField
          label={
            <>
              <FormattedMessage id="entity-type" />:
            </>
          }
          dir={dir}
          currentLocale={currentLocale}
          registerProps={register("agencyTypeId")}
          options={agencies}
          translationKey="agencyTypeTranslations"
        />

        <MicroFileItemForm label={intl.formatMessage({ id: "address" })}>
          <input type="text" className="form-control" />
        </MicroFileItemForm>

        <MicrofilmSelectField
          label={<FormattedMessage id="film-type" />}
          dir={dir}
          currentLocale={currentLocale}
          registerProps={register("filmTypeId")}
          options={films}
          translationKey="filmTypeTranslations"
        />

        <div className="form-label row">
          <div className="col-lg-4">
            <label>
              <FormattedMessage id="film-number" />
            </label>
          </div>
          <div className="col-lg-8">
            <div className="form-label-container">
              <input
                type="text"
                {...register("filmCount")}
                className={`form-control ${
                  errors.filmCount ? "is-invalid" : ""
                }`}
              />
              <span>*</span>
            </div>
          </div>
        </div>

        <div className="row-r mt-4">
          <button className="main-btn" type="submit">
            <span>
              <FormattedMessage id="send" />
            </span>
            <ChevronIcon width={12} height={12} color="#FFFFFF" />
          </button>
        </div>
      </form>
    </div>
  );
}

export default MicrofilmForm;
